import React, { useState, useEffect } from 'react';
import { Drawer, IconButton, List } from '@material-ui/core';
import {
  Home as HomeIcon,
  FormatSize as TypographyIcon,
  ArrowBack as ArrowBackIcon,
  People
} from '@material-ui/icons';
import { animateScroll as scroll } from 'react-scroll';
import SettingsIcon from '@material-ui/icons/Settings';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ReceiptIcon from '@material-ui/icons/Receipt';
import InboxIcon from '@material-ui/icons/Inbox';
import HttpsIcon from '@material-ui/icons/Https';
import ReplayIcon from '@material-ui/icons/Replay';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import { useTheme } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import isMobile from '../../utils/isMobile';

// styles
import useStyles from './styles';

// components
import SidebarLink from './components/SidebarLink/SidebarLink';

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from '../../context/LayoutContext';

const structure = [
  {
    id: 0, label: 'Dashboard', link: '/app/dashboard', icon: <HomeIcon />
  },
  {
    id: 1,
    label: 'Clientes',
    link: '/app/clientes',
    icon: <People />,
  },
  {
    id: 2,
    label: 'Cobranças',
    link: '/app/cobrancas',
    icon: <MonetizationOnIcon />,
  },
  {
    id: 5,
    label: 'Faturas',
    link: '/app/faturas',
    icon: <ReceiptIcon />,
  },
  {
    id: 3,
    label: 'Produtos',
    link: '/app/produtos',
    icon: <InboxIcon />,
  },
  {
    id: 4,
    label: 'Sistema',
    link: '/app/sistema',
    icon: <SettingsIcon />,
    children: [
      { label: 'Usuários', link: '/app/sistema/usuarios', icon: <HttpsIcon /> },
      { label: 'Acessos', link: '/app/sistema/logs', icon: <ExitToAppIcon /> },
      { label: 'Processos com falha', link: '/app/sistema/processos', icon: <ReplayIcon /> },
      // TODO: RBAC — restrict to admin role
      { label: 'Configurações Bancárias', link: '/app/sistema/configuracoes-bancarias', icon: <AccountBalanceIcon /> }
    ],
  },
];

function Sidebar({ location }) {
  const classes = useStyles();
  const theme = useTheme();

  // global
  const { isSidebarOpened } = useLayoutState();
  const layoutDispatch = useLayoutDispatch();

  // local
  const [isPermanent, setPermanent] = useState(true);
  const [mobile, setMobile] = useState(isMobile(window, theme));

  useEffect(() => {
    window.addEventListener('resize', handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener('resize', handleWindowWidthChange);
    };
  });

  return (
    <Drawer
      variant={isPermanent ? 'permanent' : 'temporary'}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />
      {mobile && (
        <div className={classes.mobileBackButton}>
          <IconButton
            onClick={() => {
              toggleSidebar(layoutDispatch);
            }}
          >
            <ArrowBackIcon
              classes={{
                root: classNames(classes.headerIcon, classes.headerIconCollapse),
              }}
            />
          </IconButton>
        </div>
      )}
      <List
        className={classes.sidebarList}
      >
        {structure.map((link) => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    const windowWidth = window.innerWidth;
    const breakpointWidth = theme.breakpoints.values.md;
    const isSmallScreen = windowWidth < breakpointWidth;

    setMobile(isMobile(window, theme));

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
      toggleSidebar(layoutDispatch);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
